import React from 'react'

const RY = () => {
    return (
        <div>

        </div>
    )
}

export default RY
